import React from "react";

/**
 * One of a fixed list of choices, kept in `localStorage` under `storageKey`.
 * Reads the stored value on mount, and falls back to `defaultChoice` when
 * there is none or it is not one of `choices`. The setter stores the new
 * choice.
 * This hook does not sync across call sites or across tabs.
 */
export default function useStoredChoice<Choice extends string>(
  storageKey: string,
  choices: readonly Choice[],
  defaultChoice: Choice
): [Choice, (choice: Choice) => void] {
  const [choice, setChoice] = React.useState<Choice>(() => {
    const storedValue = localStorage.getItem(storageKey);
    return (
      choices.find((candidate) => candidate === storedValue) ?? defaultChoice
    );
  });

  const storeChoice = (nextChoice: Choice) => {
    localStorage.setItem(storageKey, nextChoice);
    setChoice(nextChoice);
  };

  return [choice, storeChoice];
}
